"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FindRecipientResultType;
(function (FindRecipientResultType) {
    FindRecipientResultType[FindRecipientResultType["None"] = 0] = "None";
    FindRecipientResultType[FindRecipientResultType["Cache"] = 1] = "Cache";
    FindRecipientResultType[FindRecipientResultType["FindPeople"] = 2] = "FindPeople";
    FindRecipientResultType[FindRecipientResultType["SearchDirectory"] = 3] = "SearchDirectory";
})(FindRecipientResultType = exports.FindRecipientResultType || (exports.FindRecipientResultType = {}));
var ReadWriteRecipientWellSize;
(function (ReadWriteRecipientWellSize) {
    ReadWriteRecipientWellSize[ReadWriteRecipientWellSize["Small"] = 0] = "Small";
    ReadWriteRecipientWellSize[ReadWriteRecipientWellSize["Regular"] = 1] = "Regular";
})(ReadWriteRecipientWellSize = exports.ReadWriteRecipientWellSize || (exports.ReadWriteRecipientWellSize = {}));
//# sourceMappingURL=ReadWriteRecipientWellViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/store/schema/ReadWriteRecipientWellViewState.js
// module id = 2114
// module chunks = 2 3 4 45 90 108